import { STATUS_VALUES, VISIBILITY_VALUES } from '../../../components/MainListInfoForm';
export var checkIsActive = function (value) {
    return value === STATUS_VALUES.ACTIVE;
};
export var checkIsPrivate = function (value) {
    return value === VISIBILITY_VALUES.PRIVATE;
};
export var prepareDataForRequest = function (_a) {
    var description = _a.description, listName = _a.listName, visibility = _a.visibility, status = _a.status, _b = _a.fqlQuery, fqlQuery = _b === void 0 ? '' : _b, recordType = _a.recordType, fields = _a.fields;
    var object = {
        name: listName,
        description: description,
        fqlQuery: fqlQuery,
        isActive: checkIsActive(status),
        isPrivate: checkIsPrivate(visibility),
        fields: fields,
    };
    if (recordType) {
        object.entityTypeId = recordType;
    }
    return object;
};
